import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient.js';

class FixedAssetAPI extends DIApi {
  controllerName = 'fixedassets';

  /**
   * Lấy các chứng từ liên quan
   * @param {*} payload
   * @returns
   */
  getVoucherReference(payload) {
    const request = {
      url: this.getAPIUrl() + '/VoucherReference/' + payload.fixed_asset_id,
      data: payload,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu tài sản mapping
   * @param {*} payload
   * @returns
   */
  getDataMapping() {
    const request = {
      url: this.getAPIUrl() + '/DataFixedAssetMappingCircular',
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu tài sản mapping
   * @param {*} payload
   * @returns
   */
  getVoucherEffectCircular() {
    const request = {
      url: this.getAPIUrl() + '/VoucherEffectCircular',
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu tài sản mapping
   * @param {*} payload
   * @returns
   */
  updateCircular(listMapping) {
    const request = {
      url: this.getAPIUrl() + '/UpdateCircular',
      data: listMapping,
    };
    return httpClient.postAsync(request);
  }
}

export default new FixedAssetAPI();
